module.exports = __webpack_public_path__ + "img/27_fineStaff_tl.43d6c618.png";